'use strict';

var module = angular.module('doclr.components.agenda');

module.controller('agendaController', function ($scope, agendaBoundaries, AppointmentPopup) {
    $scope.agendaBoundaries = agendaBoundaries;
});